import { TranslateService } from "@ngstack/translate";
import {
  MatTreeFlattener,
  MatTreeFlatDataSource
} from "@angular/material";
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { IRole } from "src/app/interfaces/role";
import { FlatTreeControl } from "@angular/cdk/tree";
import { RoleService } from "src/app/services/http/business/role/role.service";
import { HttpHeaders } from "@angular/common/http";
interface ExampleFlatNode {
  expandable: boolean;
  Title: string;
  Id: number;
  ParentId: number;
  level: number;
}

@Component({
  selector: "app-contract-role",
  templateUrl: "./contract-role.component.html",
  styleUrls: ["./contract-role.component.css"]
})
export class ContractRoleComponent implements OnInit {
  gList: any;
  selectedId: number;
  RoleId: number;
  @Output() sendRoleId = new EventEmitter<number>();
  @Input('role') iRoleId = 0;
  @Input('company') iCompanyEncryptId = '';



  private transformer = (node: IRole, level: number) => {
    return {
      expandable: !!node.Children && node.Children.length > 0,
      Title: node.Title,
      Id: node.Id,
      ParentId: node.ParentId,
      level: level
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.Children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(
    private roleService: RoleService,
    public translate: TranslateService,
  ) {
    console.log(this.iRoleId);
    this.RoleId = this.iRoleId;
  }

  ngOnInit() {
    this.refresh();
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  refresh() {
    if (!this.iCompanyEncryptId) {
      this.roleService.list().subscribe(res => {
        this.dataSource.data = res.DataList;
      });
    }
    else {
      var headers = new HttpHeaders({
        "Content-Type": "application/json"
      })
        .append("Authorization", "Bearer " + localStorage.getItem("token"))
        .append(
          "HID",
          localStorage.getItem("holdingCode")
            ? localStorage.getItem("holdingCode")
            : ""
        )
        .append(
          "CID",
          this.iCompanyEncryptId
        );
      this.roleService.listByHeader(0, 0, headers).subscribe(
        res => {
          this.dataSource.data = res.DataList;
        }
      );
    }
  }

  onClick(id: number) {
    this.iRoleId = 0;
    this.sendRoleId.emit(id);
  }
}
